import { AuthService } from './../../_services/auth.service';
import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../_services/storage.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from '../../_models/user.model';
import { FormBuilder, Validators } from '@angular/forms';
import { Routes } from 'src/app/_config/routes.config';
import { BaseComponent } from '../base/base.component';
import { LanguageManagerService } from 'src/app/_services/languagemanager.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  standalone: false,
})
export class LoginComponent extends BaseComponent implements OnInit {

  private userSuscription!: Subscription;
  allowPasswordRecovery:Boolean = environment.allowRecoverPassword;
  loginForm;
  code:string = "password-recovery";
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];
  token: any = [];
  componentSelected: string;
  page: string;

  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    public override langService: LanguageManagerService,
    private formBuilder: FormBuilder,
    public override router: Router,
    private route: ActivatedRoute,
  ) {
    super(router, langService, route);
   }

  override ngOnInit(): void {
    super.ngOnInit();
    this.userSuscription = this.storageService.userInfo.subscribe(user => {
      this.updateUserData(user);
    });
    if (this.storageService.isLoggedIn()) {
      this.isLoggedIn = true;
      this.componentSelected = this.storageService.getComponent();
    }
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],
      pw: ['', [Validators.required]]
    });
    this.authService.authError$.subscribe(errorMessage =>{
      this.errorMessage = errorMessage;
      this.isLoginFailed = true;
    });
  }

  onSubmit(): void {
    // console.log('Log in form Value', this.loginForm.value);
    const { username, pw } = this.loginForm.value;
    this.isLoginFailed = false;
    this.errorMessage='';
    this.authService.login(username, pw)
      .catch((err) => {
        this.errorMessage = JSON.stringify(err);
        this.isLoginFailed = true;
      });
  }

  navigateLoggedIn() {
    var params = {};
    this.route.queryParams.subscribe(routeParams => {
      if (routeParams['callbackUrl']) {
        this.page = routeParams['callbackUrl'];
      }
    });
    this.router.navigate([this.page], { queryParams: params });
  }

  navigateError() {
    var params = {};
    this.page = Routes.ERROR;
    this.router.navigate([this.page], { queryParams: params });
  }

  reloadPage(): void {
    this.navigateLoggedIn();
  }

  updateUserData(user: User) {
    if (user != null) {
      let tokenData = this.authService.getTokenData();
      if (tokenData.enrollment == 'True') {
        this.page = Routes.DISPUTES;
      } else {
        // console.log('El usuario NO tiene realizado el enrollment');
        this.page = Routes.ENROLLMENT;
      }
      this.router.navigate([this.page])
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }
  }
}
